module.exports = __webpack_public_path__ + "img/AvatarSilver.0d04b7a6.svg";